import { EventHandler } from 'react';
import { CustomAny } from '../types/generics';

export const stopPropagation: EventHandler<CustomAny> = event => event.stopPropagation();
